export const HearingDatesIcon = (props) => (
  <svg fill="none" height={24} viewBox="0 0 25 24" width={25} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18.4 4.8H7.6C5.61177 4.8 4 6.41178 4 8.4V17.4C4 19.3882 5.61177 21 7.6 21H18.4C20.3882 21 22 19.3882 22 17.4V8.4C22 6.41178 20.3882 4.8 18.4 4.8Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
    <path
      d="M9.4 3V6.6M16.6 3V6.6M4 10.2H22"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
  </svg>
);
